import { render, staticRenderFns } from "./InboxThread.vue?vue&type=template&id=22c06a03&scoped=true"
import script from "./InboxThread.vue?vue&type=script&lang=js"
export * from "./InboxThread.vue?vue&type=script&lang=js"
import style0 from "./InboxThread.vue?vue&type=style&index=0&id=22c06a03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c06a03",
  null
  
)

export default component.exports